import { skipToken } from '@reduxjs/toolkit/query'
import { useAuth } from '../auth/useAuth'
import { useGetTenantQuery } from '../redux/api/customerApi'
import { useMemo } from 'react'
import { InterfleetProTags } from '../auth/authContext'

export function useIsInterfleetPro() {
  const { user } = useAuth()
  const tenant = useGetTenantQuery(user?.tenant ?? skipToken)
  const isInterfleetPro = useMemo(
    () => !!user?.is4UPro || !!tenant.currentData?.tags.some((t) => InterfleetProTags.includes(t.toLowerCase())),
    [tenant.currentData?.tags, user?.is4UPro]
  )
  return isInterfleetPro
}
